export const SUBJECT_HISTORY = 'history';
export const SUBJECT_MATH = 'math';
export const SUBJECT_ID_HISTORY = 1;
export const SUBJECT_ID_MATH = 2;